import React from 'react';
import PropTypes from 'prop-types';
import { Card } from '@salesforce/design-system-react';

const HeroCollectionCard = (props) => {
  const { imgUrl, titleUrl, description } = props;

  return (
    <Card hasNoHeader className="slds-p-left_xx-small slds-m-around_x-small" >
      <div className="slds-grid" onClick={(e) => window.open(titleUrl, '_blank')} style={{ cursor: 'pointer'}}>
        <div className="slds-align_absolute-center slds-size_1-of-4" >
          <img
            alt="hero company logo"
            src={imgUrl}
            style={{ height: '37.5px', width: 'auto' }}
          />
        </div>
       
        <p className="slds-p-bottom_xx-small slds-align_absolute-center slds-size_3-of-4 slds-p-left_x-small" style={{ fontSize: '.6rem'}}>
          {description}
        </p>
      </div>
      
    </Card>
  );
};

HeroCollectionCard.propTypes = {
  imgUrl: PropTypes.string.isRequired,
  titleUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  tags: PropTypes.array.isRequired,
};

export default HeroCollectionCard;
